module.exports = __webpack_public_path__ + "assets/img/plan6-5.02ac97ba.png";